module.exports = __webpack_public_path__ + "img/img11.59e04f2e.svg";